/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./friend.vue?vue&type=template&id=79804033&scoped=true"
import script from "./friend.vue?vue&type=script&lang=js"
export * from "./friend.vue?vue&type=script&lang=js"
import style0 from "./friend.vue?vue&type=style&index=0&id=79804033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79804033",
  null
  
)

export default component.exports